<ion-app
  [ngClass]="{
    'telegram-safe-area': isTelegram(),
  }"
>
  @if (isDownloadBannerVisible() && !isTelegram()) {
    <ion-toolbar style="--min-height: 24px !important">
      <ion-grid class="ion-no-padding" *transloco="let t; prefix: 'app-component'">
        <ion-row class="download-banner">
          <ion-col size="fill" class="download-button">
            <ion-button
              size="small"
              fill="solid"
              routerLinkActive="selected"
              (click)="openAppDownloadClick()"
              >{{ t("download-native-app") }}
            </ion-button>
          </ion-col>
          <ion-col size="auto" class="download-close-button">
            <ion-button size="small" fill="clear" (click)="closeDownloadBannerClick()">
              <app-icon
                icon="close"
                colorCss="--content-tertiary"
                sizeCss="--icon-x-large"
                slot="icon-only"
              />
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-toolbar>
  }

  <ion-content *transloco="let t; prefix: 'app-component'">
    <ion-grid style="height: 100%" class="ion-no-padding">
      <ion-row style="height: 100%">
        <ion-col style="height: 100%">
          <ion-split-pane contentId="main-content" [disabled]="!showSidebar">
            <ion-menu
              contentId="main-content"
              (ionWillOpen)="menuOpened()"
              (ionDidClose)="menuClosed()"
            >
              <div class="top-menu-padding">
                <ion-list id="inbox-list">
                  <div class="menu-logo">
                    <img [src]="themeService.appicon()" alt="t('clinch-logo-alt')" id="logo" />
                  </div>

                  @if (userStateService.onboarded) {
                    <ion-menu-toggle auto-hide="false">
                      <ion-item button="true" detail="false" lines="none" (click)="playClick()">
                        <app-icon
                          icon="play"
                          colorCss="--content-tertiary"
                          sizeCss="--icon-x-large"
                        />
                        <div class="typography-text-medium-semibold-primary menu-button">
                          {{ t("games-button") }}
                        </div>
                      </ion-item>
                    </ion-menu-toggle>
                  }
                  @if (userStateService.onboarded && customisationService.isChatEnabled()) {
                    <ion-menu-toggle auto-hide="false">
                      <ion-item button="true" detail="false" lines="none" (click)="chatClick()">
                        <app-icon
                          icon="chat"
                          colorCss="--content-tertiary"
                          sizeCss="--icon-x-large"
                        />
                        <div class="typography-text-medium-semibold-primary menu-button">
                          {{ t("chat-button") }}
                        </div>
                      </ion-item>
                    </ion-menu-toggle>
                  }
                  @if (userStateService.onboarded) {
                    <ion-menu-toggle auto-hide="false">
                      <ion-item
                        button="true"
                        routerDirection="root"
                        [routerLink]="PAGE.ACCOUNT"
                        routerLinkActive="selected"
                        detail="false"
                        lines="none"
                        (click)="profileClick()"
                      >
                        <app-icon
                          icon="user"
                          colorCss="--content-tertiary"
                          sizeCss="--icon-x-large"
                        />
                        <div class="typography-text-medium-semibold-primary menu-button">
                          {{ t("profile-button") }}
                        </div>
                      </ion-item>
                    </ion-menu-toggle>
                  }
                  @if (userStateService.onboarded && customisationService.isDownloadAppEnabled()) {
                    <ion-menu-toggle auto-hide="false">
                      <ion-item
                        button="true"
                        routerLinkActive="selected"
                        detail="false"
                        lines="none"
                        (click)="downloadAppClick()"
                      >
                        <app-icon
                          icon="download"
                          colorCss="--content-tertiary"
                          sizeCss="--icon-x-large"
                        />
                        <div class="typography-text-medium-semibold-primary menu-button">
                          {{ t("download-native-app") }}
                        </div>
                      </ion-item>
                    </ion-menu-toggle>
                  }
                  @if (!userStateService.onboarded) {
                    <ion-menu-toggle auto-hide="false">
                      <div class="ion-padding">
                        <app-icon
                          icon="start"
                          colorCss="--content-tertiary"
                          sizeCss="--icon-x-large"
                        />
                        <div class="typography-text-medium-semibold-primary menu-button">
                          {{ t("get-started-button") }}
                        </div>
                      </div>
                    </ion-menu-toggle>
                  }
                </ion-list>
              </div>

              <div class="bottom-menu-padding">
                <ion-list>
                  @if (
                    userStateService.onboarded && customisationService.isInviteMenuButtonEnabled()
                  ) {
                    <ion-menu-toggle auto-hide="false">
                      <div class="ion-margin-vertical">
                        <app-button
                          [label]="t('invite')"
                          icon="share"
                          layout="fill"
                          type="secondary"
                          (clickEvent)="sideMenuInviteClick()"
                        />
                      </div>
                    </ion-menu-toggle>
                  }

                  @if (customisationService.isLoginEnabled()) {
                    <ion-menu-toggle auto-hide="false">
                      <ion-item
                        button="true"
                        (click)="logout()"
                        detail="false"
                        lines="none"
                        style="margin-bottom: 16px"
                        (click)="logoutClick()"
                      >
                        <app-icon
                          icon="logout"
                          colorCss="--content-tertiary"
                          sizeCss="--icon-x-large"
                        />
                        <div class="typography-text-medium-semibold-primary menu-button">
                          {{ t("logout-button") }}
                        </div>
                      </ion-item>
                    </ion-menu-toggle>
                  }

                  @if (userStateService.onboarded) {
                    <ion-grid style="margin-left: 6px">
                      <ion-row size="auto">
                        <ion-col size="12" class="horizontal-link">
                          <ion-menu-toggle auto-hide="false" class="ion-no-padding">
                            <a
                              [routerLink]="PAGE.PRIVACY"
                              routerDirection="root"
                              class="link"
                              (click)="privacyClick()"
                            >
                              <div class="typography-text-small-regular-tertiary">
                                {{ t("privacy-button") }}
                              </div>
                            </a>
                          </ion-menu-toggle>
                        </ion-col>
                      </ion-row>
                      <ion-row size="auto">
                        <ion-col size="12" class="horizontal-link">
                          <ion-menu-toggle auto-hide="false" class="ion-no-padding">
                            <a
                              [routerLink]="PAGE.TERMS"
                              routerDirection="root"
                              class="link"
                              (click)="termsClick()"
                            >
                              <div class="typography-text-small-regular-tertiary">
                                {{ t("terms-button") }}
                              </div>
                            </a>
                          </ion-menu-toggle>
                        </ion-col>
                      </ion-row>
                      <ion-row size="auto">
                        <ion-col size="12" class="horizontal-link">
                          <ion-menu-toggle auto-hide="false" class="ion-no-padding">
                            <a
                              [routerLink]="PAGE.RESPONSIBLE_GAMING"
                              routerDirection="root"
                              class="link"
                              (click)="responsibleGamingClick()"
                            >
                              <div class="typography-text-small-regular-tertiary">
                                {{ t("responsible-gaming-button") }}
                              </div>
                            </a>
                          </ion-menu-toggle>
                        </ion-col>
                      </ion-row>
                      <ion-row size="auto">
                        <ion-col size="12" class="horizontal-link">
                          <ion-menu-toggle auto-hide="false" class="ion-no-padding">
                            <a
                              [routerLink]="PAGE.FAQ"
                              routerDirection="root"
                              class="link"
                              (click)="faqClick()"
                            >
                              <div class="typography-text-small-regular-tertiary">
                                {{ t("faq-button") }}
                              </div>
                            </a>
                          </ion-menu-toggle>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  }
                </ion-list>
              </div>
            </ion-menu>

            <ion-router-outlet
              id="main-content"
              [animated]="false"
              [swipeGesture]="false"
            ></ion-router-outlet>
          </ion-split-pane>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</ion-app>
